import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { getPagePath, withClientConfig } from '@spotahome/bff/client';
import { withSubscription, Mediator } from '@spotahome/soyuz-mediator';
import { getLoggedInUserInfo } from '@spotahome/soyuz-auth-client';

import {
  Header,
  MenuIcon,
  Logo,
  Modal,
  AccountNotValidatedBanner
} from '@spotahome/ui-library';
import '@spotahome/ui-library/lib/components/Header.css';
import '@spotahome/ui-library/lib/components/MenuIcon.css';
import '@spotahome/ui-library/lib/components/MobileMenu.css';
import '@spotahome/ui-library/lib/components/Modal.css';
import '@spotahome/ui-library/lib/components/AccountNotValidatedBanner.css';

import { OPEN_MENU, TOKEN_EXPIRED } from '../channels';
import { resendActivationUser } from '../api/traditional-login-client';

import HeaderNav from './HeaderNav';
import MobileNav from './MobileNav';
import AppBanner from './AppBanner';

import './HeaderContainer.scss';

const OPTIONS = ['home', 'list-your-property', 'how-it-works', 'favorites'];
const SESSION_EXPIRED_STATUS = 401;

async function requestLoggedInUserInfo() {
  try {
    const response = await getLoggedInUserInfo();
    return response.data.email
      ? {
          email: response.data.email,
          verified: response.data.isActivatedByEmail,
          id: response.data.id
        }
      : null;
  } catch (err) {
    if (err.response && err.response.status === SESSION_EXPIRED_STATUS) {
      Mediator.publish(TOKEN_EXPIRED);
    } else {
      throw new Error(err);
    }
  }
}

function resendLink(id) {
  try {
    resendActivationUser(id);
  } catch (err) {
    console.log(err);
  }
}

const HeaderContainerSubscribed = withClientConfig()(
  withSubscription({ channelName: OPEN_MENU })(props => (
    <Fragment>
      {props.clientConfig.featureToggle.traditionalLoginResendLink && (
        <AccountNotValidatedBanner
          getLoggedInUserInfo={requestLoggedInUserInfo}
          resendLinkCB={resendLink}
        />
      )}
      <header className="header-menu-wrapper">
        {props.withAppBanner && <AppBanner />}

        <Header
          shadow
          logo={
            <a
              className="ga-menu-home"
              href={getPagePath('externals.landing-pages.home')}
              style={{ lineHeight: 0 }}
            >
              <Logo light size="medium" />
            </a>
          }
          menuIcon={<MenuIcon color="dark" onMenuClick={props.toggleMenu} />}
        >
          <HeaderNav options={OPTIONS} />
        </Header>
        <Modal contentLabel="modal" size="fullscreen" isOpen={props.isMenuOpen}>
          <MobileNav options={OPTIONS} onClose={props.toggleMenu} />
        </Modal>
      </header>
    </Fragment>
  ))
);

HeaderContainerSubscribed.propTypes = {
  withAppBanner: PropTypes.bool.isRequired,
  toggleMenu: PropTypes.func.isRequired,
  isMenuOpen: PropTypes.bool.isRequired
};

class HeaderContainer extends PureComponent {
  static propTypes = {
    withAppBanner: PropTypes.bool
  };

  static defaultProps = {
    withAppBanner: false
  };

  state = {
    isMenuOpen: false
  };

  toggleMenu = () =>
    this.setState(({ isMenuOpen }) => ({ isMenuOpen: !isMenuOpen }));

  displayMenu = () => this.setState({ isMenuOpen: true });

  render() {
    return (
      <HeaderContainerSubscribed
        withAppBanner={this.props.withAppBanner}
        toggleMenu={this.toggleMenu}
        isMenuOpen={this.state.isMenuOpen}
        onEvent={this.displayMenu}
      />
    );
  }
}

export default withClientConfig()(HeaderContainer);
